export default __webpack_public_path__ + "static/media/AWS-CDA.0e269028.md";